export default {
  color: 'gray900',
  fontSize: '16px',
  fontWeight: 'medium',
  textDecoration: 'none',
  userSelect: 'none',
  whiteSpace: 'pre',
  transition: 'all 250ms ease',
  p: 0,
  ':visited': {
    color: 'gray900',
  },
  ':hover': {
    textDecoration: [null, 'none', null, null, 'underline'],
  },
};
